(function() {
  const faqTitles = document.querySelectorAll('.faq__itemTitle');
  const faqContentTitles = document.querySelectorAll('.faq__itemContentTitle');

  function toggleDropdown(target) {
    const currentItem = target.closest('.faq__item');
    const currentContent = target.nextElementSibling;

    if (currentItem.classList.contains('faq__item--active')) {
      currentItem.classList.remove('faq__item--active');
      currentItem.style.height = 'auto';
      currentContent.style.height = '0px';
      return;
    }

    currentItem.classList.add('faq__item--active');
    currentContent.style.height = `${currentContent.scrollHeight}px`;
  }

  function toggleContentDropdown(target) {
    const currentWrapper = target.closest('.faq__itemContent');
    const currentContent = currentWrapper.querySelector('.faq__itemContentDescription');
    const activeFirstLevel = target.closest('.faq__item.faq__item--active');

    if (currentWrapper.classList.contains('faq__itemContent--active')) {
      currentWrapper.classList.remove('faq__itemContent--active');
      currentContent.style.height = '0px';
      activeFirstLevel.style.height = `${activeFirstLevel.scrollHeight - currentContent.scrollHeight}px`;
    } else {
      currentWrapper.classList.add('faq__itemContent--active');
      currentContent.style.height = `${currentContent.scrollHeight}px`;
      activeFirstLevel.style.height = `${activeFirstLevel.scrollHeight + currentContent.scrollHeight}px`;
    }
  }

  faqContentTitles.forEach((title) => {
    title.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleContentDropdown(e.currentTarget);
    });
  });

  faqTitles.forEach((title) => {
    title.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleDropdown(e.currentTarget);
    });
  });
})();
